import { css } from '@emotion/react';
import { useState } from 'react';
import { CompanyPeriodRequestStatus } from '../../../schemas/CompanyPeriodRequest.schema';
import { dateToPlainDateString } from '../../../util/date-utilts';
import { KpiManageMenuBar } from '../components/KPIRequests/Manage/KpiRequestManage';
import { CompanyPeriodRequestManageViewModel } from './company-period-request.view-model';
import { CompanyPeriodRequestManageGrid } from './CompanyPeriodRequestManageGrid';
import { KpiDocsExportButton } from './KpiDocsExportButton';

type CompanyPeriodRequestManageData = {
  requests: CompanyPeriodRequestManageViewModel[];
  includedCompanies: Map<number, string>;
  requestStats: Map<CompanyPeriodRequestStatus | string, number>;
};

const wrapperCss = css`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  padding: 1rem;
  row-gap: 0.5rem;
  width: 100%;
  min-width: 0;
`;

type CompanyPeriodRequestManageProps = CompanyPeriodRequestManageData & {
  allStatuses: CompanyPeriodRequestStatus[];
  onDateRangeChange: (from: Date | null, to: Date | null) => void;
  onSelectedCompanyChange: (companyId: number | undefined) => void;
  selectedCompanyId: number | undefined;
  selectedDates: [Date, Date];
  mode?: 'v1' | 'v2';
};

function CompanyPeriodRequestManage(props: CompanyPeriodRequestManageProps) {
  const {
    allStatuses,
    includedCompanies,
    requests,
    requestStats,
    onDateRangeChange,
    onSelectedCompanyChange,
    selectedCompanyId,
    selectedDates,
    mode,
  } = props;
  const [selectedStatus, setSelectedStatus] = useState('All');

  return (
    <div css={wrapperCss}>
      <KpiManageMenuBar
        includedCompanies={includedCompanies}
        allStatuses={allStatuses}
        onDateRangeChange={onDateRangeChange}
        onSelectedCompanyChange={onSelectedCompanyChange}
        onSelectedStatusChange={setSelectedStatus}
        requestStats={requestStats}
        selectedCompanyId={selectedCompanyId}
        selectedStatus={selectedStatus}
        rightAction={
          <KpiDocsExportButton
            companyIds={selectedCompanyId ? [selectedCompanyId] : undefined}
            dateFrom={dateToPlainDateString(selectedDates[0])}
            dateTo={dateToPlainDateString(selectedDates[1])}
          />
        }
      />
      <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', minWidth: 0 }}>
        <CompanyPeriodRequestManageGrid requests={requests} selectedStatus={selectedStatus} mode={mode} />
      </div>
    </div>
  );
}

export { CompanyPeriodRequestManage };
